export default "__VITE_ASSET__DjBt9Vzh__"